// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indicator-style2[data-v-57f2a644] {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.indicator-style2 .indicator-style-item-content[data-v-57f2a644] {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/charts/indicatorStyle/style2.vue","webpack://./style2.vue"],"names":[],"mappings":"AA6CA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AC5CJ;ADwCA;EAMQ,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;AC3CR","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.indicator-style2 {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    .indicator-style-item-content {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        margin-left: 12px;\n    }\n}\n",".indicator-style2 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.indicator-style2 .indicator-style-item-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-left: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
